{
  "blocks": [
    {
      "id": "proc-sperm-collection",
      "kind": "procedure",
      "tags": ["ivf", "iui", "his", "during-cycle"],
      "title": "Sperm Collection",
      "subtitle": "Providing a semen sample for IUI, IVF, freezing, or analysis",
      "body": {
        "procedureName": "Sperm Collection",
        "category": "retrieval",
        "description": "Providing a semen sample for IUI, IVF, freezing, or analysis. Usually done at the clinic on the day of the procedure.",
        "howItWorks": "A semen sample is collected by masturbation into a sterile cup, typically in a private room at the clinic. For IVF, the sample is needed on the morning of egg retrieval. The lab processes the sample, washing and concentrating the healthiest sperm. In cases where ejaculation isn't possible, surgical sperm retrieval (TESA, micro-TESE) may be performed under sedation.",
        "duration": "Variable (collection) + 1-2 hours (processing)",
        "painAndComfort": [
          "Collection itself is not usually painful, though the setting or process may feel stressful or uncomfortable."
        ],
        "prepInstructions": [
          "Follow the clinic's recommended abstinence window, often 2–5 days before collection",
          "Ask whether home collection is allowed and how quickly the sample must reach the lab"
        ],
        "whatToExpect": [
          "Private collection room at the clinic",
          "2-5 days of abstinence recommended before collection",
          "Sample is processed and prepared by the lab",
          "Results include count, motility, and morphology",
          "Backup frozen sample may be recommended"
        ],
        "results": [
          {
            "label": "Processing time",
            "detail": "The lab usually processes the sample within 1-2 hours, especially if it is needed for IUI or IVF the same day."
          },
          {
            "label": "What you learn",
            "detail": "The lab may report count, motility, morphology, or post-wash numbers depending on why the sample was collected."
          },
          {
            "label": "Backup plan",
            "detail": "If the sample is low or collection is difficult, the clinic may use a frozen backup or discuss surgical retrieval."
          }
        ],
        "forWhom": "him",
        "frBody": {
          "procedureName": "Recueil de sperme",
          "description": "Recueil d'un échantillon de sperme pour IIU (insémination intra-utérine), FIV (fécondation in vitro), congélation ou analyse. Réalisé habituellement à la clinique le jour de la procédure.",
          "howItWorks": "Le recueil se fait par masturbation dans un récipient stérile, généralement dans une pièce privative à la clinique. Pour une FIV, l'échantillon est requis le matin de la ponction. Le laboratoire prépare l'échantillon en lavant et en concentrant les spermatozoïdes les plus sains. Lorsque l'éjaculation n'est pas possible, un prélèvement chirurgical (TESA, micro-TESE) peut être réalisé sous sédation.",
          "duration": "Variable (recueil) + 1 à 2 heures (préparation)",
          "whatToExpect": [
            "Pièce privative pour le recueil à la clinique",
            "Abstinence éjaculatoire de 2 à 5 jours recommandée avant le recueil",
            "L'échantillon est préparé par le laboratoire",
            "Les résultats incluent numération, mobilité et morphologie",
            "Un échantillon congelé de sécurité peut être conseillé"
          ],
          "results": [
            {
              "label": "Temps de préparation",
              "detail": "Le laboratoire prépare généralement l'échantillon en 1 à 2 heures, surtout s'il est nécessaire pour une IIU ou une FIV le jour même."
            },
            {
              "label": "Ce que vous apprenez",
              "detail": "Le laboratoire peut communiquer numération, mobilité, morphologie ou chiffres après préparation selon l'objectif du recueil."
            },
            {
              "label": "Plan de secours",
              "detail": "Si l'échantillon est faible ou difficile à obtenir, le centre peut utiliser une réserve congelée ou discuter un prélèvement chirurgical."
            }
          ]
        }
      },
      "sources": [
        {
          "title": "WHO Laboratory Manual for the Examination and Processing of Human Semen, 6th Edition",
          "authors": "World Health Organization",
          "journal": "WHO Publications",
          "year": 2021,
          "url": "https://www.who.int/publications/i/item/9789240030787",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [
    {
      "from": "proc-sperm-collection",
      "to": "test-semen-analysis",
      "type": "related-to",
      "label": "Procedure used for"
    }
  ],
  "localeVariants": []
}
